module.exports = __webpack_public_path__ + "img/logo_head.30e6a5ee.svg";